// Lazysizes
import "lazysizes";

// Alpine components

document.addEventListener("alpine:init", () => {

    Alpine.directive(
        "number",
        (el, { expression, modifiers }, { evaluateLater, effect }) => {
            const [modLang, modCurrency] = modifiers

            const getValue = evaluateLater(expression)

            const options = {};
            if (modCurrency) {
                options.style = "currency";
                options.currency = modCurrency;
            }

            effect(() => {
                getValue((value) => {
                    const formatted = new Intl.NumberFormat(modLang, options).format(value)
                    el.innerText = formatted
                })
            })
        }
    )


    Alpine.data("pagination", () => ({
        nextLink: '',
        loadingNext: false,
        setNextLink(doc) {
            const nextLink = doc.querySelector('[x-ref="nextLink"]');
            this.nextLink = nextLink ? nextLink.getAttribute('href') : '';
        },
        loadNext() {
            fetch(this.nextLink)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const container = doc.querySelector('[x-ref="container"]');
                    this.$refs.container.insertAdjacentHTML('beforeend', container.innerHTML);
                    this.setNextLink(doc);
                });
        },
        init() {
            this.setNextLink(this.$root);
            // hide pagination
            this.$refs.pagination.style.display = 'none';
        }
    }));


    Alpine.data("form", () => ({
        isValid: true,
        submitting: false,
        form: null,
        init() {
            this.form = this.$root.closest("form");

            this.form.addEventListener("submit", (e) => {
                this.isValid = window.v.isValid(this.form);
                if (this.isValid) {
                    this.submitting = true;
                }
            });
        },
    }));

    Alpine.data("modal", (id) => ({
        id,
        init() {
            this.toggleByHash();
            window.addEventListener("hashchange", this.toggleByHash);
        },
        toggleByHash() {
            if (id) {
                var hash = window.location.hash;
                if (hash.startsWith("#")) {
                    hash = hash.substring(1);
                }

                this.showModal = hash == this.id;
            }
        },
        showModal: false,
        closeModal() {
            this.showModal = false;
        },
        toggleModal() {
            this.showModal = !this.showModal;
        },
    }));

    Alpine.data("fadeIn", (delay = 0, duration = 300) => ({
        visible: false,
        directives: {
            ["x-show"]() {
                return this.visible;
            },
            [`x-transition.opacity.duration.${duration}ms.delay.${delay}ms`]() { },
        },
        init() {
            this.$nextTick(() => (this.visible = true));
        },
    }));

    Alpine.data("scrollRender", () => ({
        intersected: false,
        directives: {
            ["x-bind:class"]() {
                return { intersected: !this.intersected };
            },
            ["x-on:keyup.tab.window"]() {
                this.intersected = true;
            },
            ["x-intersect.once"]() {
                this.intersected = true;
            },
        },
    }));

    // Magic: $tooltip
    Alpine.magic("tooltip", (el) => (message) => {
        let instance = tippy(el, {
            content: message,
            trigger: "manual",
            theme: "gi",
        });

        instance.show();

        setTimeout(() => {
            instance.hide();

            setTimeout(() => instance.destroy(), 150);
        }, 2000);
    });

    // Directive: x-tooltip
    Alpine.directive("tooltip", (el, { expression }) => {
        tippy(el, { content: expression, theme: "gi" });
    });


    Alpine.data("addressSearch", (token = "") => ({
        init() {
            this.form = this.$root.closest("form");
        },

        form: null,

        zipCodeResults: [],
        lookupPostalCode(ev) {
            if (ev.target.value.length == 4) {
                fetch(
                    "https://api.dataforsyningen.dk/rest/gsearch/v2.0/postnummer?q=" +
                    ev.target.value +
                    "&token=" + token
                )
                    .then((response) => response.json())
                    .then((data) => {
                        this.zipCodeResults = data.map((d) => {
                            return {
                                zip: d.postnummer,
                                city: d.postnummernavn,
                            };
                        });
                    });
            } else {
                this.zipCodeResults = [];
            }
        },
        setZipCode(item) {
            this.form.querySelector("#zipCode").value = item.zip;
            this.form.querySelector("#city").value = item.city;
            this.zipCodeResults = [];
        },

        addressResults: [],
        lookupAddress(ev) {
            if (ev.target.value.length > 2) {
                let url = `https://api.dataforsyningen.dk/rest/gsearch/v2.0/adresse?q=${ev.target.value}&token=${token}`;

                if (this.form.querySelector("#zipCode").value) {
                    url = `${url}&filter=postnr%3D${this.form.querySelector("#zipCode").value}`;
                }

                fetch(url)
                    .then((response) => response.json())
                    .then((data) => {
                        data = data.map(item => {
                            item.tekst = item.visningstekst;
                            return item;
                        });

                        var dataUniqueByKey = [...new Map(data.map(item => [item.tekst, item])).values()];
                        this.addressResults = dataUniqueByKey;
                    });
            } else {
                this.addressResults = [];
            }
        },
        setAddress(item) {
            this.form.querySelector("#streetName").value =
                item.vejnavn;
            this.form.querySelector("#houseNumber").value =
                item.husnummer;
            this.form.querySelector("#zipCode").value =
                item.postnummer;
            this.form.querySelector("#city").value =
                item.postnummernavn;
            this.addressResults = [];
        },
    }));

    Alpine.data(
        "search",
        (autocomplete = false, category = null, value = null) => ({
            autocomplete,
            category,
            value,
            items: [],
            showWarning: false,
            isLoading: false,
            isShowResults: false,
            isListening: false,
            startVoiceSearch() {
                const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                if (!SpeechRecognition) return;
                const recognition = new SpeechRecognition();
                recognition.lang = document.documentElement.lang || 'da-DK';
                recognition.interimResults = false;
                recognition.maxAlternatives = 1;
                this.isListening = true;
                recognition.start();
                recognition.onresult = (event) => {
                    this.value = event.results[0][0].transcript;
                    this.isListening = false;
                    this.onChange();
                };
                recognition.onerror = () => { this.isListening = false; };
                recognition.onend = () => { this.isListening = false; };
            },
            handleKeydownArrow(add) {
                var items = this.$refs.list?.querySelectorAll("a");

                console.log(items);
                if (items && items.length > 0) {
                    // get index of item in focus
                    var index =
                        Array.prototype.indexOf.call(items, document.activeElement) + add;
                    index = Math.min(Math.max(index, 0), items.length - 1);
                    // focus element at index
                    items[index].focus();
                }
            },
            getCategory(category) {
                switch (category) {
                    case "Publications":
                        return "Publikation";
                    case "Projects":
                        return "Projekt";
                    case "Courses":
                        return "Kursus";
                    case "News":
                        return "Nyhed";
                    case "Pages":
                        return "Side";
                    default:
                        return category;
                }
            },
            onFocus() {
                this.isShowResults = true;
            },
            async onChange() {
                if (this.autocomplete) {
                    if (this.trimQuery(this.value).length >= 3) {
                        this.showWarning = false;
                        this.getResults();
                    } else {
                        this.showWarning = true;
                    }
                }
            },
            async getResults() {
                this.isLoading = true;

                fetch("/umbraco/search/search/search", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        query: this.value,
                        page: 1,
                        itemsPerPage: 5,
                        categories: "courses,projects,publications,news,pages",
                    }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.items = data.searchResults;
                        this.isLoading = false;
                        this.isShowResults = true;
                    });
            },
            trimQuery(query = "") {
                return query.replace(/\s+/g, " ").trim();
            },
        })
    );
});

// aspnet-client-validation bootup

import { ValidationService } from "aspnet-client-validation";

window.v = new ValidationService();
window.v.addProvider("mustbetrue", (value, element, params) => {
    return element.checked;
});
window.v.addProvider("onemustbetrue", (value, element, params) => {
    var elementNames = element.dataset?.valOnemustbetrueOf?.split(",");
    if (!elementNames) {
        return true;
    }
    var elements = [
        ...element
            .closest("form")
            .querySelectorAll('[name="' + elementNames.join('"],[name="') + '"]'),
    ];
    return elements.filter((e) => e.checked).length > 0;
});

window.v.bootstrap();


window.getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};